/**
 *   create by zhanghang
 */
import { lazy } from 'react'
import withLazyLoad from '@/components/withLazyLoad/withLazyLoad'
import { InterRouteConfig } from './router.d'
const Index = withLazyLoad(lazy(() => import('@/pages/Index').then((module: any) => ({ default: module.default }))))
const ThesisTopic = withLazyLoad(
  lazy(() => import('@/pages/ThesisTopic/ThesisTopic').then((module: any) => ({ default: module.default })))
)
const Plans = withLazyLoad(lazy(() => import('@/pages/Plans/Plans').then((module: any) => ({ default: module.default }))))
const References = withLazyLoad(
  lazy(() => import('@/pages/References/References').then((module: any) => ({ default: module.default })))
)
const Major = withLazyLoad(lazy(() => import('@/pages/Major/Major').then((module: any) => ({ default: module.default }))))
const Catalog = withLazyLoad(lazy(() => import('@/pages/Catalog/Catalog').then((module: any) => ({ default: module.default }))))
const CreatePPT = withLazyLoad(
  lazy(() => import('@/pages/CreatePPT/CreatePPT').then((module: any) => ({ default: module.default })))
)
const SurePPTCatalog = withLazyLoad(
  lazy(() => import('@/pages/SurePPTCatalog/SurePPTCatalog').then((module: any) => ({ default: module.default })))
)
const SelectPPTTheme = withLazyLoad(
  lazy(() => import('@/pages/SelectPPTTheme/SelectPPTTheme').then((module: any) => ({ default: module.default })))
)
const ResulePPT = withLazyLoad(
  lazy(() => import('@/pages/ResulePPT/ResulePPT').then((module: any) => ({ default: module.default })))
)
const Reduce = withLazyLoad(lazy(() => import('@/pages/Reduce/Reduce').then((module: any) => ({ default: module.default }))))
const ReduceSelect = withLazyLoad(
  lazy(() => import('@/pages/ReduceSelect/ReduceSelect').then((module: any) => ({ default: module.default })))
)
const ReduceResult = withLazyLoad(
  lazy(() => import('@/pages/ReduceResult/ReduceResult').then((module: any) => ({ default: module.default })))
)
// const OpenReport = withLazyLoad(
//   lazy(() => import('@/pages/Paper/OpenReport').then((module: any) => ({ default: module.default })))
// )
// const LiteratureReview = withLazyLoad(
//   lazy(() => import('@/pages/Paper/LiteratureReview').then((module: any) => ({ default: module.default })))
// )
// const GraduationThesis = withLazyLoad(
//   lazy(() => import('@/pages/Paper/GraduationThesis').then((module: any) => ({ default: module.default })))
// )
// const CoursePaper = withLazyLoad(
//   lazy(() => import('@/pages/Paper/CoursePaper').then((module: any) => ({ default: module.default })))
// )
const Body = withLazyLoad(lazy(() => import('@/pages/Body/Body').then((module: any) => ({ default: module.default }))))
const ArticleLayout = withLazyLoad(
  lazy(() => import('@/pages/ArticleLayout/ArticleLayout').then((module: any) => ({ default: module.default })))
)
const SelectTemplate = withLazyLoad(
  lazy(() => import('@/pages/SelectTemplate/SelectTemplate').then((module: any) => ({ default: module.default })))
)
const LayoutResult = withLazyLoad(
  lazy(() => import('@/pages/LayoutResult/LayoutResult').then((module: any) => ({ default: module.default })))
)
const ExampleBody = withLazyLoad(
  lazy(() => import('@/pages/ExampleBody/ExampleBody').then((module: any) => ({ default: module.default })))
)
const asyncRouter: InterRouteConfig[] = [
  {
    path: '/',
    name: 'Index',
    exact: true,
    children: [],
    components: Index
  },
  {
    path: '/thesisTopic/:id',
    name: 'ThesisTopic',
    exact: true,
    children: [],
    step: 1,
    type: 1,
    components: ThesisTopic
  },
  {
    path: '/plans/:id',
    name: 'Plans',
    exact: true,
    children: [],
    step: 2,
    type: 1,
    components: Plans
  },
  {
    path: '/major/:id',
    name: 'Major',
    exact: true,
    children: [],
    step: 2,
    type: 1,
    components: Major
  },
  {
    path: '/references/:id',
    name: 'References',
    exact: true,
    children: [],
    step: 3,
    type: 1,
    components: References
  },
  {
    path: '/catalog/:id',
    name: 'Catalog',
    exact: true,
    children: [],
    step: 4,
    type: 1,
    components: Catalog
  },
  {
    path: '/body',
    name: 'Body',
    exact: true,
    children: [],
    components: Body
  },
  // {
  //   path: '/openReport',
  //   name: 'OpenReport',
  //   exact: true,
  //   children: [],
  //   components: OpenReport
  // },
  // {
  //   path: '/literatureReview',
  //   name: 'LiteratureReview',
  //   exact: true,
  //   children: [],
  //   components: LiteratureReview
  // },
  // {
  //   path: '/graduationThesis',
  //   name: 'GraduationThesis',
  //   exact: true,
  //   children: [],
  //   components: GraduationThesis
  // },
  // {
  //   path: '/coursePaper',
  //   name: 'CoursePaper',
  //   exact: true,
  //   children: [],
  //   components: CoursePaper
  // },
  {
    path: '/createPPT',
    name: 'CreatePPT',
    exact: true,
    children: [],
    step: 1,
    type: 2,
    components: CreatePPT
  },
  {
    path: '/surePPTCatalog',
    name: 'SurePPTCatalog',
    exact: true,
    children: [],
    step: 2,
    type: 2,
    components: SurePPTCatalog
  },
  {
    path: '/selectPPTTheme',
    name: 'SelectPPTTheme',
    exact: true,
    children: [],
    step: 3,
    type: 2,
    components: SelectPPTTheme
  },
  {
    path: '/resulePPT',
    name: 'ResulePPT',
    exact: true,
    children: [],
    step: 4,
    type: 2,
    components: ResulePPT
  },
  {
    path: '/reduce/:id',
    name: 'Reduce',
    exact: true,
    children: [],
    step: 1,
    type: 3,
    components: Reduce
  },
  {
    path: '/reduceSelect/:id',
    name: 'ReduceSelect',
    exact: true,
    children: [],
    step: 2,
    type: 3,
    components: ReduceSelect
  },
  {
    path: '/reduceResult/:id',
    name: 'ReduceResult',
    exact: true,
    children: [],
    step: 3,
    type: 3,
    components: ReduceResult
  },
  {
    path: '/articleLayout',
    name: 'ArticleLayout',
    exact: true,
    children: [],
    step: 1,
    type: 5,
    components: ArticleLayout
  },
  {
    path: '/selectTemplate',
    name: 'SelectTemplate',
    exact: true,
    children: [],
    step: 2,
    type: 5,
    components: SelectTemplate
  },
  {
    path: '/layoutResult',
    name: 'LayoutResult',
    exact: true,
    children: [],
    step: 3,
    type: 5,
    components: LayoutResult
  },
  {
    path: '/exampleBody',
    name: 'ExampleBody',
    exact: true,
    children: [],
    components: ExampleBody
  }
]
export default asyncRouter
